@if (hasRequestedCode()) {
<app-auth-shell title="Verifique que é você" icon="fas fa-shield-halved">
  <p class="auth-login__subtitle">Digite o código de 6 dígitos enviado para <strong>{{ formOtp.get('email')?.value }}</strong>.</p>
  <form class="auth-login__form" role="form" [formGroup]="formOtp" (ngSubmit)="verifyCode()" novalidate>
    <div class="auth-field">
      <app-auth-code-input formControlName="code" label="Código do e-mail" [autofocus]="true" />
      <div class="auth-login__code-meta">
        @if (validitySeconds() > 0) {
        <div class="auth-field__hint">Código válido por {{ formatCountdown(validitySeconds()) }}</div>
        } @else {
        <div class="auth-field__error">Código expirado. Solicite outro.</div>
        }
      </div>
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formOtp.valid || validitySeconds() === 0">Verificar e entrar</button>
  </form>
  <div class="auth-login__actions">
    <p class="auth-login__note">
      Não recebeu o código?
      <button type="button" class="auth-link" (click)="requestCode()" [disabled]="remainingSeconds() > 0">
        @if (remainingSeconds() > 0) { Reenviar em {{ formatCountdown(remainingSeconds()) }} } @else { Reenviar código }
      </button>
    </p>
    <p class="auth-login__note">
      <button type="button" class="auth-link" (click)="changeEmail()">Usar outro e-mail</button>
    </p>
  </div>
  <p class="auth-login__signup" authShellFooter>
    Prefere usar a senha?
    <a [routerLink]="['/signin']">Voltar para o login</a>
  </p>
</app-auth-shell>
} @else {
<app-auth-shell title="Entrar com código no e-mail" subtitle="Enviaremos um código de 6 dígitos para o seu e-mail confirmado.">
  <form class="auth-login__form" role="form" [formGroup]="formOtp" (ngSubmit)="requestCode()" novalidate>
    <div class="auth-field">
      <label class="auth-field__label" for="email">E-mail</label>
      <div class="auth-field__control">
        <input id="email" type="email" formControlName="email" class="auth-field__input" placeholder="nome@empresa.com" autocomplete="email" appFocus />
      </div>
      @if (formOtp.get('email')?.dirty) { @if (formOtp.get('email')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formOtp.get('email')?.hasError('email')) {
      <div class="auth-field__error">E-mail inválido</div>
      } }
    </div>
    <button type="submit" class="auth-btn" [disabled]="!!formOtp.get('email')?.invalid || remainingSeconds() > 0">
      @if (remainingSeconds() > 0) { Reenviar em {{ formatCountdown(remainingSeconds()) }} } @else { Enviar código }
    </button>
  </form>
  <p class="auth-login__signup" authShellFooter>
    Prefere usar a senha?
    <a [routerLink]="['/signin']">Voltar para o login</a>
  </p>
</app-auth-shell>
}
